import { SecShape, type SecondaryDef } from '../../sim/secondary';

/** S01 — LANCE PERFORANTE. L'arme de départ, et la plus lisible des quatre.
 *
 *  ── Le besoin ────────────────────────────────────────────────────────────
 *  Les vagues du monde 1 arrivent en FILE dans un couloir (voir bloc-a et
 *  bloc-b) : trois ou quatre ennemis alignés sur la même verticale. La primaire
 *  les traite un par un, du premier au dernier, et pendant ce temps la file
 *  descend. La Lance traverse toute la file d'un coup.
 *
 *  ── Comment la perforation existe sans exister ───────────────────────────
 *  Un projectile joueur meurt sur sa première cible — il n'y a pas de champ
 *  « perforation » dans le pool, et c'était le bon choix : l'ajouter coûterait
 *  une branche dans la boucle de collision, qui est la plus chaude du jeu.
 *  Alors on triche par la géométrie. Six projectiles empilés sur 230 u de haut
 *  arrivent sur la même ligne à 21 ms d'intervalle : le premier ouvre, les cinq
 *  suivants continuent. Ce que le joueur voit est un trait qui transperce ; ce
 *  que le moteur fait est six collisions ordinaires.
 *
 *  ── L'équilibrage ────────────────────────────────────────────────────────
 *  600 dégâts sur 5 s = 120 DPS, soit 60 % de la primaire, et seulement si les
 *  six touchent. Sur une cible isolée elle est franchement bonne (un Rôdeur à
 *  240 PV tombe en deux projectiles sur six) ; sur une file elle est
 *  spectaculaire. C'est exactement le profil voulu : jamais mauvaise, jamais
 *  suffisante seule. */
const lance: SecondaryDef = {
  id: 'lance-perforante',
  name: 'Lance perforante',
  shape: SecShape.Lance,
  cooldown: 5,
  shots: 1,
  shotEvery: 0,
  count: 6,
  // 46 u entre deux projectiles : assez pour qu'ils se lisent comme une file et
  // non comme un bloc, assez peu pour que la colonne entière tienne dans la
  // hauteur d'une vague et frappe la même file d'ennemis.
  spacing: 46,
  spreadDeg: 0,
  // Plus rapide que la primaire (1 800) : la Lance doit DOUBLER le tir courant,
  // sinon elle traverse son propre rideau et ses projectiles de tête se
  // consument sur des ennemis déjà condamnés.
  speed: 2200,
  radius: 16,
  damage: 100,
  text: '6 × 100 dégâts en colonne perforante — 5 s',
};

export default lance;
